module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/hpack.js/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 220
// module chunks = 0